export const DRAWER_WIDTH = 330;

export const DRAWER_PADDING = 24;

export const DRAWER_HEADER_HEIGHT = 56;

export const DRAWER_FOOTER_HEIGHT = 64;

export const ACTION_HEADER_OFFSET = 20;

export const CONTACT_MODAL_POPCONFIRM_WIDTH = 240;
